import { Dayjs } from 'dayjs';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/lib/date-picker/generatePicker';
import 'antd/lib/date-picker/style/index';
import generateCalendar from 'antd/lib/calendar/generateCalendar';
import 'antd/lib/calendar/style/index';

export const DatePicker = generatePicker<Dayjs>(dayjsGenerateConfig);
export const Calendar = generateCalendar<Dayjs>(dayjsGenerateConfig);
